import { SB } from '@play-co/replicant';
import { getPetAssetKey, speciesChatbot } from './species';
import { createFlexMessageTemplate, createFlexContainer } from './utils';
import { FlexComponent } from './types';
import { buildSender } from '../sender';

/**
 * Share flex message request
 * https://developers.line.biz/en/docs/line-login/using-line-url-scheme/#sending-text-messages
 *
 *
 * https://developers.line.biz/en/reference/messaging-api/#uri-action
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const shareFlexMessage = createFlexMessageTemplate(
  SB.object({
    species: SB.tuple(speciesChatbot),
    petName: SB.string(),
    message: SB.string(),
    share: SB.string(),
    buttons: SB.object({
      yes: SB.string(),
      no: SB.string(),
    }),
  }),
  (data, _, api) => {
    const altText = data.message;
    const normal = api.getAssetPath(getPetAssetKey(data.species));

    // If user agree to share
    const shareButton = {
      type: 'button',
      style: 'primary',
      height: 'sm',
      action: {
        type: 'uri',
        label: data.buttons.yes,
        uri: 'https://line.me/R/share?text=' + encodeURIComponent(data.share),
      },
    };

    // If user don't want to share
    const notNowButton = {
      type: 'button',
      style: 'secondary',
      height: 'sm',
      action: {
        type: 'message',
        label: data.buttons.no,
        text: data.buttons.no,
      },
    };

    const template = createFlexContainer(altText, {
      type: 'bubble',
      body: {
        type: 'box',
        layout: 'vertical',
        contents: [
          {
            type: 'text',
            text: data.message, // Icebreaker message
            size: 'md',
            wrap: true,
          },
        ],
        backgroundColor: '#ECECEC',
      },
      footer: {
        type: 'box',
        layout: 'vertical',
        spacing: 'sm',
        contents: [shareButton, notNowButton] as FlexComponent[],
        flex: 0,
      },
    });

    // Add sender to message
    template['sender'] = buildSender({ name: data.petName, iconUrl: normal });

    return template;
  },
);
